export default {
  default: {
    maxFileSizeNote: 'Max 50mb each',
  },
}
